export default {
  init() {
    const elements = document.querySelectorAll(".book-full__table-clipboard");

    for (const element of elements) {
      const trigger = element.querySelector(".book-full__table-clipboard-icon");

      trigger.addEventListener("click", () => {
        const value = element.querySelector("div").textContent;
        const icon = trigger.querySelector("i");
        navigator.clipboard.writeText(value.trim()).then(() => {
          icon.classList.remove("fa-copy");
          icon.classList.add("fa-check");
          setTimeout(() => {
            icon.classList.remove("fa-check");
            icon.classList.add("fa-copy");
          }, 1000);
        });
      });
    }
  },
};
